import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _remove from 'lodash/remove';
import _isEmpty from 'lodash/isEmpty';
import { Button, Spinner } from 'react-bootstrap';
import _find from 'lodash/find';
import _uniqBy from 'lodash/uniqBy';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _cloneDeep from 'lodash/cloneDeep';
import { addItemToCart2 } from '../../../actions/cart';
import { setPartHistory } from '../MyGarage/mygarage.thunks';
import { timeInUTC, isStockOrder, getConsolidatedCartData, deliveryPickupWarning } from '../../../helpers/utils';

const actionTypes = {
  SELECTED_ADDCART_DATA: 'SELECTED_ADDCART_DATA',
  ADDTO_CART_WARNING: 'ADDTO_CART_WARNING'
};

const AddToCartV2 = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const mygarage = useSelector((state) => state.mygarage);
  const orderType = useSelector((state) => state.cart.orderType);
  const checkoutDetails = useSelector((state) => state.cart.checkoutDetails);
  const categoryGroupMap = useSelector((state) => state.parts.categoryGroupMap);

  const { model, modelId, make, makeId, engine, engineId, year, internalMakeId } = mygarage.selectedVehicle || {};

  let { disabled, selectedAvailabilityHours: initialSelectedAvailabilityHours, source, buttonStyle, fromPage, tableView, shouldRenderInput, row, handleKeyDown, defaultValue, IsEmptyInput, resetCallBack } = props;

  const [loading, setLoading] = useState(false);
  const [selectedAvailabilityHours, setSelectedAvailabilityHours] = useState(initialSelectedAvailabilityHours || []);

  // Sync state with props in case selectedAvailabilityHours changes in props
  useEffect(() => {
    setSelectedAvailabilityHours(initialSelectedAvailabilityHours);
  }, [initialSelectedAvailabilityHours]);

  const handleInputOnBlur = (e) => {
    let { part, partNum } = row;
    let { target: { value } } = e;
    let previousQuanity = 0;
    value = _isEmpty(value) ? 0 : Number(value);

    let requestPayload = _cloneDeep(checkoutDetails);
    requestPayload = getConsolidatedCartData(requestPayload);
    if (true) {
      const filteredItems = requestPayload.filter(item => item.partNum === partNum);

      if (filteredItems.length > 0) {
        const indexToUpdate = requestPayload.findIndex(item => item.partNum === partNum);
        previousQuanity = requestPayload[indexToUpdate].qty;
        if (previousQuanity === value) {
          return;
        }
        if (indexToUpdate !== -1) {
          requestPayload[indexToUpdate] = {
            ...requestPayload[indexToUpdate],
            qty: value,
            source: 'cart'
          };
        }
      }

      if (!_isEmpty(value) && Number(value) !== 0) {
        value = Number(value);
      }
      if (Number(value) === 0) {
        IsEmptyInput(part);
        e.target.value = previousQuanity;
      } else {
        addToCart(null, requestPayload);
      }
    }
  };

  const addToCart = (event = null, requestPayload = {}) => {
    if (event) {
      event.preventDefault();
    }
    setLoading(true);

    const cartData = !_isEmpty(requestPayload) ? requestPayload : selectedAvailabilityHours;
    dispatch({
      payload: {
        selectedAddCartData: _cloneDeep(cartData),
      },
      type: actionTypes.SELECTED_ADDCART_DATA,
    });

    let currentCart = {};
    currentCart.checkoutDetails = checkoutDetails

    if (source !== 'cartpreview' && cartData.length > 0 && deliveryPickupWarning(user.userDetails, currentCart, cartData[0]?.store, cartData[0]?.shipMethod)) {
      dispatch({
        payload: {
          addToCartWarning: true,
        },
        type: actionTypes.ADDTO_CART_WARNING,
      });
      setLoading(false);
      return;
    }

    if (source !== 'cartpreview' && isStockOrder(orderType)) {
      dispatch({
        payload: {
          addToCartWarning: true,
        },
        type: actionTypes.ADDTO_CART_WARNING,
      });
      setLoading(false);
    } else {
      let updatedAvailabilityHours = _remove(cartData, (a) => Number(a.qty) > 0);

      if (!_isEmpty(updatedAvailabilityHours) && user && user.userDetails) {
        const { userDetails: { x2userName, shipTos, billTo } } = user;

        addItemToCart2(updatedAvailabilityHours, dispatch, true, user, fromPage)
          .then(() => {
            let uniqsah = _uniqBy(updatedAvailabilityHours, 'descId');
            uniqsah.forEach((s) => {
              if (!_isEmpty(s.descId)) {
                const payload = {
                  categoryId: Number(
                    _find(categoryGroupMap, (c) => {
                      return _includes(
                        _map(c.groups, 'code'),
                        Number(s.groupId)
                      );
                    })?.code
                  ),
                  createdBy: x2userName,
                  createdDate: timeInUTC(),
                  customerId: billTo.billToId,
                  engine: engine?.trim() || '',
                  engineId,
                  groupId: s.groupId,
                  lastOrderedDate: timeInUTC(),
                  make: make?.trim() || '',
                  makeId,
                  internalMakeId,
                  model: model?.trim() || '',
                  modelId,
                  orderedFlag: 'N',
                  partTypeDesc: s.desc,
                  partTypeDescId: s.descId,
                  searchPartId: '',
                  shipToId: shipTos[0].shipToId,
                  source,
                  updatedBy: x2userName,
                  updatedDate: timeInUTC(),
                  userFilter: 'selected',
                  year: year?.trim() || '',
                  orderType: "REGULAR"
                };
                if (source !== 'cartpreview') {
                  dispatch(setPartHistory(payload));
                }
              }
            });
            if (resetCallBack) {
              resetCallBack();
            }
          })
          .finally(() => setLoading(false));
      } else {
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      {tableView ? shouldRenderInput ? (
        <>
          <input
            className={row.validationRed ? "table_qty_order border-red" : "table_qty_order"}
            type="text"
            name="totalQty"
            defaultValue={defaultValue}
            onBlur={(e) => handleInputOnBlur(e)}
            onKeyDown={handleKeyDown}
            disabled={disabled || loading}
          />
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
        </>
      ) : (
        <span className="table-add-to-cart-button">
          <Button
            type="button"
            disabled={disabled}
            onClick={(e) => addToCart(e)}
            className="btn btn-primary"
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <i className="fa fa-shopping-cart" aria-hidden="true"></i>
            )}
          </Button>
        </span>
      ) : (
        <Button
          className={buttonStyle ? buttonStyle : "add-to-cart-btn"}
          onClick={() => addToCart()}
          disabled={disabled}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            'Add to cart'
          )}
        </Button>
      )}
    </Fragment>
  );
};

export default AddToCartV2;
